/* eslint-disable prefer-rest-params, prefer-spread, prefer-const -- verbatim Meta Pixel snippet */
export const FbPixel = {
    initialize: () => {
        if (FbPixel.element) {
            return console.warn('Pixel already initialized');
        }
        FbPixel.element = true;

        !function(f, b, e, v, n, t, s) {
            if (f.fbq) return; n=f.fbq=function() {
                n.callMethod?
                    n.callMethod.apply(n, arguments):n.queue.push(arguments);
            };
            if (!f._fbq)f._fbq=n; n.push=n; n.loaded=!0; n.version='2.0';
            n.queue=[]; t=b.createElement(e); t.async=!0;
            t.src=v; s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        }(window, document, 'script',
            'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '6187957774626501');
        fbq('track', 'PageView');

        window.fbAsyncInit = function() {
            FB.init({
                appId: '6187957774626501',
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v3.2',
            });
        };

        (function(d, s, id) {
            let js; const fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s); js.id = id;
            js.src = 'https://connect.facebook.net/en_US/sdk.js';
            js.async = true;
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    },
};
